import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { Maybe } from '@graphql/generated';

const InsightSection = ({ title, text }: { title: string; text: string }) => (
  <Flex
    flexDirection="column"
    gap={1}
  >
    <TextV2
      typographyVariant="label3"
      color="mono8"
    >
      {title}
    </TextV2>
    <TextV2 typographyVariant="body1">{text}</TextV2>
  </Flex>
);

interface AutoPopulatedAccommodationInsightContent
  extends Readonly<{
    whyThisHotelIsAGreatPick?: Maybe<string>;
    proposedNoteFromHostToGuest?: Maybe<string>;
  }> {}

export const AutoPopulateInsight = ({ insight }: { insight: AutoPopulatedAccommodationInsightContent }) => {
  const { tq } = useTranslation('travelAdmin');

  if (!insight.whyThisHotelIsAGreatPick && !insight.proposedNoteFromHostToGuest) {
    return null;
  }

  return (
    <Flex
      flexDirection="column"
      gap={3}
      backgroundColor="mono1"
      borderRadius={3}
      paddingX={5}
      paddingY={4}
    >
      {insight.whyThisHotelIsAGreatPick && (
        <InsightSection
          title={tq`Why this hotel is a great pick`}
          text={insight.whyThisHotelIsAGreatPick}
        />
      )}
      {insight.proposedNoteFromHostToGuest && (
        <InsightSection
          title={tq`Proposed note from host to guest`}
          text={insight.proposedNoteFromHostToGuest}
        />
      )}
    </Flex>
  );
};
